import React from "react";

import "./ScrollIndicator.scss";

export const ScrollIndicator = ({ className = "", text = "", style = {} }) => {
  return (
    <div className={`scroll-indicator ${className}`} style={{ ...style }}>
      {text.length > 0 ? (
        <div className="scroll-indicator__text block-font">{text}</div>
      ) : null}
      <svg
        role="img"
        aria-label="Scroll to continue"
        className="scroll-indicator__icon"
      >
        <use xlinkHref="#chevron-down"></use>
      </svg>
    </div>
  );
};
